import { usePathname } from '@framework/next/navigation';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { isProfileLockedWithoutAddOn } from '../isProfileLockedWithoutAddOn';

// TODO: remove when the European market opening period ends
export const useIsProfileLockedWithoutAddOn = (): boolean => {
  const pathname = usePathname();
  const { plan, features } = useUserPlanContext();
  const { pageFilters } = usePageFiltersContext();

  return isProfileLockedWithoutAddOn(pathname, { plan, features }, pageFilters);
};
